<template>
  <div class="navigation">
    <router-link
      class="navigation-item"
      v-for="item in navs"
      :key="item.name"
      :class="{ active: active === item.name }"
      :to="item.path"
      v-if="item.meta.navigation"
    >
      {{ item.name }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Navigation",
  data() {
    return {
      active: this.$route.name,
      navs: this.$router.options.routes,
    };
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped lang="less">
.navigation {
  width: 550px;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  user-select: none;

  &-item {
    width: 130px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: url("../assets/images/footer-released.png") no-repeat center;
    background-size: 100% 100%;
    font-size: 16px;
    color: #e6f9ff;
    font-family: sans-serif;
    font-weight: bold;
    cursor: pointer;
    text-decoration: none;

    &.active {
      background: url("../assets/images/footer-selected.png") no-repeat center;
      background-size: 100% 100%;
    }
  }
}
</style>
